import commonObj from "../../services/common.js";
import { HTTP } from "../../services/api-service.js";
var common = new commonObj();
var baseUrl = common.baseURL;

const localizationStore = {
  namespaced: true,
  actions: {
    getWordList({ commit }, param) {
      return new Promise((resolve, reject) => {
        if (param.LanguageCode === "E") {
          param.LanguageCode = "EN";
        } else if (param.LanguageCode === "C") {
          param.LanguageCode = "TC";
        }
        HTTP.post(baseUrl + "/localization/" + param.LanguageCode + "/messages")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getLanguages({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/localization/languages")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default localizationStore;
